import { Box, Icon, Link, Text } from "@chakra-ui/react";
import React from "react";
import { SiGmail } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { GrLinkedin } from "react-icons/gr";
import { FiPhoneCall } from "react-icons/fi";


const ContactUs = () => {
  return (
    <Box marginTop="5%" pt="3%" bg="RGBA(0, 0, 0, 0.04)">
     
      <Box
    
        display="grid"
        mr={[0, 10, 10, 10]}
        gridTemplateColumns={[
          "repeat(1,1fr)",
          "repeat(1,1fr)",
          "repeat(1,1fr)",
          "repeat(4,1fr)",
        ]}
      >
        <Link
          
          fontSize={["xl", "3xl", "2xl"]}
          display="flex"
          alignItems="center"
          m="auto"
          mt="10px"
          gap="20px"
          href="mailto:Princeranu98@gmail.com"
          fontFamily="Serif"
          _hover={{
            border:"none",
            textDecoration: "none" ,
            transitionDuration: "1000ms",
            transform:"scale(1.1)",
            cursor:"pointer",
          
          }}
        >
          Gmail
          <Icon boxSize={["40px", "40px", "20px"]} as={SiGmail} />
        </Link>
        <Link
         _hover={{
          border:"none",
          textDecoration: "none" ,
          transitionDuration: "1000ms",
          transform:"scale(1.1)",
          cursor:"pointer",
        
        }}
          fontSize={["xl", "3xl", "2xl"]}
          display="flex"
          alignItems="center"
          m="auto"
          mt="20px"
          gap="20px"
          href="https://github.com/mrprincesingh"
          target="_blank"
          fontFamily="Serif"
        >
          Github
          <Icon boxSize={["40px", "40px", "20px"]} as={VscGithub} />
        </Link>
        <Link
         _hover={{
          border:"none",
          textDecoration: "none" ,
          transitionDuration: "1000ms",
          transform:"scale(1.1)",
          cursor:"pointer",
        
        }}
          fontSize={["xl", "3xl", "2xl"]}
          display="flex"
          alignItems="center"
          m="auto"
          mt="20px"
          gap="20px"
          href="https://www.linkedin.com/in/prince-singh-a35963199/"
          target="_blank"
          fontFamily="Serif"
        >
          Linkedin
          <Icon boxSize={["40px", "40px", "20px"]} as={GrLinkedin} />
        </Link>
        <Link
          _hover={{
            border:"none",
            textDecoration: "none" ,
            transitionDuration: "1000ms",
            transform:"scale(1.1)",
            cursor:"pointer",
          
          }}
          fontSize={["xl", "3xl", "2xl"]}
          display="flex"
          alignItems="center"
          m="auto"
          mt="20px"
          gap="20px"
          href="tel:8073898728"
          target="_blank"
          fontFamily="Serif"
        >
          Contact No.
          <Icon boxSize={["40px", "40px", "20px"]} as={FiPhoneCall} />
        </Link>
      </Box>
      <Box>
        <Text
          fontFamily="Serif"
          textAlign="center"
          fontSize={["sm", "lg", "xl", "2xl"]}
          mt="60px"
        >
          Contact No:- 8073898728
        </Text>
        <Text
          fontFamily="Serif"
          textAlign="center"
          fontSize={["sm", "lg", "xl", "2xl"]}
        >
          Gmail: Princeranu98@gmail.com.
        </Text>
        <Text
          fontFamily="Serif"
          textAlign="center"
          fontSize={["sm", "lg", "xl", "2xl"]}
        >
          Made By @Prince Singh.
        </Text>
      </Box>
    </Box>
  );
};

export default ContactUs;
